<template>
  <FirstDraftLanguageTooltip :show="isNonEnglish">
    <FirstDraftButton
      :disabled="isDisabled"
      class="pa-0"
      variant="plain"
      height="24"
      @click="onClick"
    >
      <span class="text-button-2">
        Iterate with First Draft
      </span>
    </FirstDraftButton>
  </FirstDraftLanguageTooltip>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useFirstDraft } from '@/stores/document/firstDraft';
import { useEditor } from '@/stores/editor/editor';
import { useTracking } from '@/stores/tracking/tracking';
import FirstDraftButton from '@ui/components/firstDraft/FirstDraftButton.vue';
import FirstDraftLanguageTooltip from '@/components/firstDraft/FirstDraftLanguageTooltip.vue';

export default {
  name: 'FirstDraftButtonForSubmenu',
  components: { FirstDraftButton, FirstDraftLanguageTooltip },

  computed: {
    ...mapState(useFirstDraft, { isDisabled: 'disabled' }),
    ...mapState(useEditor, ['isNonEnglish']),
  },

  methods: {
    ...mapActions(useFirstDraft, ['setModalVisible', 'reset', 'generateNewContent']),

    onClick() {
      useTracking().trackName({ name: 'Clicked: Iterate with First Draft' });

      this.reset();
      this.setModalVisible(true);
      this.generateNewContent();
    },
  },
};
</script>
